module.exports = __webpack_public_path__ + "assets/images/project/vietnamese-porcelain.jpg?v=44e3b847";